import { createSlice, createAsyncThunk, type PayloadAction } from '@reduxjs/toolkit';
import type { SkillsType } from 'models/competencias_model';
import { getSkills, saveKinderSkills } from 'repositories/competencias_repository';

interface SkillsState {
  skills: SkillsType | null;
  loading: boolean;
  error: string | null;
}

const initialState: SkillsState = {
  skills: null,
  loading: false,
  error: null,
};

export const getKinderSkills = createAsyncThunk(
  'skills/getKinderSkills',
  async (_, { rejectWithValue }) => {
    try {
      return (await getSkills()) ?? [];
    } catch {
      return rejectWithValue('Error al cargar habilidades');
    }
  },
);

export const saveSkills = createAsyncThunk(
  'skills/saveSkills',
  async (data: SkillsType, { rejectWithValue }) => {
    try {
      await saveKinderSkills(data);
    } catch {
      return rejectWithValue('Error al guardar habilidades');
    }
  },
);

export const skillsSlice = createSlice({
  name: 'skills',
  initialState,
  reducers: {
    setSkills: (state, action: PayloadAction<SkillsType>) => {
      state.skills = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getKinderSkills.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getKinderSkills.fulfilled, (state, action) => {
        state.loading = false;
        state.skills = action.payload;
      })
      .addCase(getKinderSkills.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const { setSkills } = skillsSlice.actions;
export default skillsSlice.reducer;
